import kea = require('node_modules/kea-react/dist/index');
import { cacheResource, bindResource } from "kea-resource";

const interval = 5;

/**Ejecuta una acción después de cierto tiempo de inactividad. Devuelve una función que al ejecutar cancela el contador */
export function EnInactividad(segundos: number, action: () => void): () => void {
    const keyCacheInactividad = "keyCacheInactividad";
    /**Obtiene la fecha de hoy en segundos */
    const hoy = () => new Date().valueOf() / 1000;
    /**Obtiene el tiempo transcurrido en segundos desde el ultimo resetInterval */
    const transcurrido = () => hoy() - kea.cookies.Get(keyCacheInactividad);
    const resetInterval = () => {
        kea.cookies.Set(keyCacheInactividad, hoy());
    }
    const handleInterval = () => {
        const t = transcurrido();
        if (t >= segundos) {
            action();
        }
    }

    window.addEventListener("mousedown", resetInterval)
    window.addEventListener("keydown", resetInterval)

    //Reseteamos el intervalo:
    resetInterval();
    const intervalIndex = setInterval(handleInterval, interval * 1000);

    return () => {
        clearInterval(intervalIndex);
        window.removeEventListener("mousedown", resetInterval);
        window.removeEventListener("keydown", resetInterval);
    };
}



// WEBPACK FOOTER //
// ./app/resources/items/inactividad.ts